import { useEffect, useState } from "react";
import Footer from "../Dashboard/Footer";
import { get, post, put, del } from "../../../api";
import Admin from "../Dashboard/Admin";
import { FormProvider, useForm } from "react-hook-form";
import { Input } from "../../Common/FormControl/Input";
import { formatDateString } from "../../../utils/date";

const UserManagement = () => {
  const [userDetail, setUserDetail] = useState();
  const [isLoading, setLoading] = useState(true);
  const [applicants, setApplicants] = useState([]);
  const [filterUser, setFilterUser] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [editingUser, setEditingUser] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [apiMessageType, setApiMessageType] = useState("");

  const { register } = useForm();
  const initialValues = {
    firstName: "",
    lastName: "",
    addressFirstLine: "",
    addressSecondLine: "",
    city: "",
    postCode: "",
    phone: "",
    email: "",
  };

  const methods = useForm({
    mode: "onTouched",
    defaultValues: { ...initialValues },
  });

  const onSubmitUser = methods.handleSubmit(async (basicDetails) => {
    console.log("Basic Details", basicDetails);
    setApiMessage("");
    
    if (isEditMode) {
      // Update existing user
      await handleUpdateUser(basicDetails);
    } else {
      // Create new user
      setLoading(true);
      const payload = {
        firstName: basicDetails?.firstName,
        lastName: basicDetails?.lastName,
        addressFirstLine: basicDetails?.addressFirstLine,
        addressSecondLine: basicDetails?.addressSecondLine,
        city: basicDetails?.city,
        postCode: basicDetails?.postCode,
        phone: basicDetails?.phone,
        email: basicDetails?.email,
        companyName: basicDetails?.carehome,
        role: basicDetails?.role,
        password: "123456",
      };
      try {
        const url = `/user/users/manage/register`;
        const response = await post(url, payload);
        if (response?.status === 202 || response?.status === 201) {
          setApiMessage("User created successfully!");
          setApiMessageType("success");
          methods.reset();
          fetchUsers(0);
        } else {
          setApiMessage("Failed to create user. Please try again.");
          setApiMessageType("error");
        }
      } catch (error) {
        setApiMessage("Error creating user. Please try again.");
        setApiMessageType("error");
        console.log("error", error);
      }
      setLoading(false);
    }
  });

  useEffect(() => {
    // const session = getSession(EMPLOYR_LOGIN_SESSION);
    fetchUsers(currentPage);
  }, [currentPage]);

  const fetchUsers = async (page) => {
    setLoading(true);
    const url = `/user/users/manage/list?page=${page}&size=10`;
    try {
      const response = await get(url);
      setUserDetail(response);
      setFilterUser(response);
      setTotalPages(response?.totalPages || 0);
      console.log("profile response", response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setIsEditMode(true);
    // Populate form with user data
    methods.reset({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phone: user.phone,
      addressFirstLine: user.addressFirstLine,
      addressSecondLine: user.addressSecondLine,
      city: user.city,
      postCode: user.postCode,
      role: user.role,
      carehome: user.company?.companyName || ""
    });
  };

  const handleUpdateUser = async (userData) => {
    setLoading(true);
    setApiMessage("");
    const payload = {
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      addressFirstLine: userData?.addressFirstLine,
      addressSecondLine: userData?.addressSecondLine,
      city: userData?.city,
      postCode: userData?.postCode,
      phone: userData?.phone,
      email: userData?.email,
      companyName: userData?.carehome,
      role: userData?.role,
    };
    
    try {
      const url = `/user/users/manage/${editingUser.userId}`;
      const response = await put(url, payload);
      if (response?.status === 200 || response?.status === 202) {
        setApiMessage("User updated successfully!");
        setApiMessageType("success");
        setIsEditMode(false);
        setEditingUser(null);
        methods.reset();
        fetchUsers(currentPage);
      } else {
        setApiMessage("Failed to update user. Please try again.");
        setApiMessageType("error");
      }
    } catch (error) {
      setApiMessage("Error updating user. Please try again.");
      setApiMessageType("error");
      console.log("error", error);
    }
    setLoading(false);
  };

  const handleDeleteUser = async (userId) => {
    if (window.confirm("Are you sure you want to deactivate this user?")) {
      setLoading(true);
      setApiMessage("");
      
      try {
        const url = `/user/users/manage/${userId}`;
        const response = await del(url);
        if (response?.status === 200) {
          setApiMessage("User deactivated successfully!");
          setApiMessageType("success");
          fetchUsers(currentPage);
        } else {
          setApiMessage("Failed to deactivate user. Please try again.");
          setApiMessageType("error");
        }
      } catch (error) {
        setApiMessage("Error deactivating user. Please try again.");
        setApiMessageType("error");
        console.log("error", error);
      }
      setLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
    setEditingUser(null);
    methods.reset();
  };

  const searchUser = (event) => {
    const value = event?.target?.value;
    if (value) {
      const list = userDetail?.content?.filter((x) =>
        String(x?.firstName).toLowerCase().includes(String(value).toLowerCase())
      );
      console.log("list", list);
      setFilterUser({ ...userDetail, content: list });
      setApplicants(list);
      console.log("setFilterUser", applicants);
    } else {
      setFilterUser(userDetail);
    }
  };

  // Generate pagination controls
  const renderPagination = () => {
    const pages = [];
    // Add previous button
    pages.push(
      <li key="prev" className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
        <button 
          className="page-link" 
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 0}
        >
          Previous
        </button>
      </li>
    );

    // Add page numbers
    // Show limited pages if there are many
    const startPage = Math.max(0, currentPage - 2);
    const endPage = Math.min(totalPages - 1, currentPage + 2);
    
    if (startPage > 0) {
      // Add first page and ellipsis if needed
      pages.push(
        <li key={0} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(0)}>1</button>
        </li>
      );
      if (startPage > 1) {
        pages.push(<li key="ellipsis1" className="page-item disabled"><span className="page-link">...</span></li>);
      }
    }
    
    // Add numbered pages
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
          <button 
            className="page-link" 
            onClick={() => handlePageChange(i)}
          >
            {i + 1}
          </button>
        </li>
      );
    }
    
    if (endPage < totalPages - 1) {
      // Add ellipsis and last page if needed
      if (endPage < totalPages - 2) {
        pages.push(<li key="ellipsis2" className="page-item disabled"><span className="page-link">...</span></li>);
      }
      pages.push(
        <li key={totalPages - 1} className="page-item">
          <button 
            className="page-link" 
            onClick={() => handlePageChange(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    // Add next button
    pages.push(
      <li key="next" className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
        <button 
          className="page-link" 
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages - 1}
        >
          Next
        </button>
      </li>
    );

    return (
      <nav aria-label="User pagination">
        <ul className="pagination justify-content-center">
          {pages}
        </ul>
      </nav>
    );
  };

  console.log("userDetail", userDetail);
  return (
    <>
      <div className="page-wrapper dashboard ">
        <Admin />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="upper-title-box">
              <h3>Manage Users</h3>
            </div>

            <div className="row">
              <div className="col-lg-12">
                {/* <!-- Ls widget --> */}
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-title"></div>

                    <div className="widget-content">
                      <div className="default-tabs style-two tabs-box">
                        {/* <!--Tabs Box--> */}
                        <ul className="tab-buttons clearfix">
                          <li className="tab-btn active-btn" data-tab="#tab1">
                            <span className="la la-user-shield"></span> User
                            Management
                          </li>
                        </ul>

                        <div className="tabs-content">
                          {/* <!--Inbox--> */}
                          <div
                            className="tab active-tab animated fadeIn"
                            id="tab1"
                            style={{ display: "block" }}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="notification-widget ls-widget">
                                  <div className="tabs-box">
                                    <div className="widget-title">
                                      <h4>Add/Edit Users</h4>

                                      <div className="filter-block">
                                        <div className="form-group">
                                          <input
                                            type="text"
                                            name="listing-search"
                                            placeholder="Search User"
                                            onChange={searchUser}
                                          />
                                          <span className="icon flaticon-search-3"></span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="widget-content">
                                      <div className="table-outer">
                                        <table className="default-table">
                                          <thead>
                                            <tr>
                                              <th>Action</th>
                                              <th>Name</th>
                                              <th>Email</th>
                                              <th>Phone</th>
                                              <th>Role</th>
                                              <th>Creation Date</th>
                                              <th>Status</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {isLoading ? (
                                              <tr>
                                                <td colSpan="7" className="text-center">
                                                  Loading...
                                                </td>
                                              </tr>
                                            ) : filterUser?.content?.length === 0 ? (
                                              <tr>
                                                <td colSpan="7" className="text-center">
                                                  No users found
                                                </td>
                                              </tr>
                                            ) : (
                                              filterUser?.content?.map(
                                                (user) => (
                                                  <tr key={user?.userId}>
                                                    <td
                                                      style={{
                                                        paddingLeft: "0",
                                                      }}
                                                    >
                                                      <div className="option-box">
                                                        <ul className="option-list">
                                                          <li>
                                                            <button 
                                                              data-text="Edit"
                                                              onClick={() => handleEditUser(user)}
                                                            >
                                                              <span className="la la-pencil"></span>
                                                            </button>
                                                          </li>
                                                          <li>
                                                            <button 
                                                              data-text="De-activate"
                                                              onClick={() => handleDeleteUser(user.userId)}
                                                            >
                                                              <span className="la la-trash text-danger"></span>
                                                            </button>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </td>
                                                    <td>
                                                      {user?.firstName}{" "}
                                                      {user?.lastName}
                                                    </td>
                                                    <td>{user?.email}</td>
                                                    <td>{user?.phone}</td>
                                                    <td>
                                                      {user?.role ===
                                                      "CANDIDATE" ? (
                                                        <span className="badge bg-primary">
                                                          {user?.role}
                                                        </span>
                                                      ) : (
                                                        <span className="badge bg-success">
                                                          {user?.role
                                                            ?.split("_")
                                                            ?.join(" ")}
                                                        </span>
                                                      )}
                                                    </td>
                                                    <td>
                                                      {formatDateString(
                                                        user?.startDate
                                                      )}
                                                    </td>
                                                    <td className="text-primary">
                                                      {user?.status}
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                      {/* Pagination */}
                                      {!isLoading && totalPages > 0 && (
                                        <div className="pagination-container mt-4">
                                          {renderPagination()}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-lg-12">
                                {/* Success/Error Messages */}
                                {apiMessage && (
                                  <div className={`alert ${apiMessageType === 'success' ? 'alert-success' : 'alert-danger'} alert-dismissible fade show`} role="alert">
                                    {apiMessage}
                                    <button type="button" className="btn-close" onClick={() => setApiMessage("")} aria-label="Close"></button>
                                  </div>
                                )}
                                
                                <div className="form-inner login-form default-form">
                                  <h4>{isEditMode ? 'Edit User' : 'Add New User'}</h4>
                                  {isEditMode && (
                                    <div className="mb-3">
                                      <button 
                                        type="button" 
                                        className="btn btn-secondary btn-sm"
                                        onClick={handleCancelEdit}
                                      >
                                        Cancel Edit
                                      </button>
                                    </div>
                                  )}
                                  <FormProvider {...methods}>
                                    <form
                                      onSubmit={(e) => e.preventDefault()}
                                      noValidate
                                    >
                                      <div className="btn-box row content-elements">
                                        <div className="form-group col-lg-6 col-md-12">
                                          <label>Role</label>
                                          <select
                                            name="role"
                                            className="chosen-select-role"
                                            placeholder="Select role"
                                            {...register("role")}
                                          >
                                            <option value={"MPLOYR_ADMIN"}>
                                              Mployr Admin
                                            </option>
                                            <option value={"CAREHOME_USER"}>
                                              CareProvider User
                                            </option>
                                            <option value={"CANDIDATE"}>
                                              Candidate
                                            </option>
                                          </select>
                                        </div>
                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="Care Provider"
                                            type="text"
                                            name="carehome"
                                            placeholder="Search or Type New"
                                          />
                                        </div>
                                      </div>

                                      <div className="btn-box row">
                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="First Name"
                                            type="text"
                                            name="firstName"
                                            placeholder="First Name"
                                          />
                                        </div>

                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="Last Name"
                                            type="text"
                                            name="lastName"
                                            placeholder="Last Name"
                                          />
                                        </div>
                                      </div>

                                      <div className="btn-box row">
                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="Address 1"
                                            type="text"
                                            name="addressFirstLine"
                                            placeholder="Address Line 1"
                                          />
                                        </div>

                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="Address 2"
                                            type="text"
                                            name="addressSecondLine"
                                            placeholder="Address Line 2"
                                          />
                                        </div>
                                      </div>

                                      <div className="btn-box row">
                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="City"
                                            type="text"
                                            name="city"
                                            placeholder="City"
                                            required=""
                                          />
                                        </div>

                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="Post Code"
                                            type="text"
                                            name="postCode"
                                            placeholder="Post Code"
                                          />
                                        </div>
                                      </div>

                                      <div className="btn-box row">
                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="Phone"
                                            type="text"
                                            name="phone"
                                            placeholder="Phone Number"
                                            required=""
                                          />
                                        </div>
                                        <div className="form-group col-lg-6 col-md-12">
                                          <Input
                                            label="Email"
                                            type="text"
                                            name="email"
                                            placeholder="Email Address"
                                            required=""
                                          />
                                        </div>
                                      </div>

                                      <div className="form-group col-lg-2 col-md-12">
                                        <button
                                          className="theme-btn btn-style-one"
                                          type="submit"
                                          name="Savebasic"
                                          onClick={onSubmitUser}
                                          disabled={isLoading}
                                        >
                                          {isLoading ? 'Processing...' : (isEditMode ? 'Update User' : 'Save')}
                                        </button>
                                      </div>
                                    </form>
                                  </FormProvider>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
export default UserManagement;
